export default __webpack_public_path__ + "static/media/epic-logo.618911b0.svg";